<template>
    <div>
        <Header navbar="hearKnowledge"></Header>
        <div class="app-container companyEva_wrap">

            <div
                style="background: #FFFFFF;display: flex;border-radius: 8px;width: 1200px;text-align: center;margin: 0 auto;font-size: 20px;height: 60px;line-height: 60px;font-size: 20px;position: relative;margin-bottom: 20px;">
                <div @click="goTo" style="cursor: pointer; width: 100px;"> <i class="el-icon-arrow-left"></i>
                    返回 </div>
                <div style="width: 1000px;  text-overflow: ellipsis;white-space: nowrap; overflow: hidden;">
                    {{ name }}
                </div>


            </div>
            <div class="btn_wrap">
                <el-button @click="exportImg" type="primary" class="downLoad_class">下载图片</el-button>
                <el-button @click="exportPDF" type="primary" class="downLoad_class" style="top: 55px; right: -40px;">
                    导出PDF</el-button>
            </div>

            <div class="report-box" id="reportBox" ref="pdfContent">
                <div class="report_1">
                    <img src="../../assets/statstics/编组@2x.png" alt="">
                    <div class="report_1_wrap">
                        <div class="report_title">{{ detail.deptName }}</div>
                        <h3 class="report_name">人才综合能力测评报告</h3>
                        <div class="report_year">({{ detail.year }})</div>
                    </div>
                </div>
                <div class="report_bg report_2">
                    <div class="report_bg_wrap">
                        <div class="report_bg_header">
                            <div class="report_bg_tips">
                                <span>01</span>
                            </div>
                            <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                        </div>
                        <div class="report_bg_title">写在前面</div>
                        <div class="report_content">
                            <p> 千秋基业，人才为本。这是做好人才工作的重大战略，必须把人才资源开发放在最优先位置，立足实际、突出重点，全方位培养、引进、用好人才，大力营造识才爱才敬才用才的环境，着力培养造就一支政治坚定、业务扎实、作风过硬的人才队伍，奋力开创人才工作新局面。
                            </p>
                            <p>基于人力资源管理领域的经典方法论和专业观点，我们开发了财税领域人力资源能力学习与提升体系，系统完整的覆盖开展财税工作的五大领域五十四模块，其中领域包括管理会计、税务会计、财务会计、内部审计、职业素养，模块包括但不限于管理会计、税收政策、会计制度、财税信息化、管理工具、制度建设、职责权限、执行能力、团队协作等等。
                            </p>
                            <p>一整套经过科学验证的测评工具与人工干预相结合，帮助贵公司全面了解自己组织人才能力分布，这些数据和洞察将为贵公司提供重要的人才管理参考，真正把人才红利转化为企业长久的增长动力。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="report_bg report_3">
                    <div class="report_bg_wrap">
                        <div class="report_bg_header">
                            <div class="report_bg_tips">
                                <span>02</span>
                            </div>
                            <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                        </div>
                        <div class="report_bg_title">本次测评基本数据</div>
                        <div class="report_content">
                            <p>本次测评共计参加考试
                                <span style="color: #1D5D99; font-size: 24px;" v-if="detail.allUserNum">{{ detail.allUserNum
                                }}</span>
                                <span style="color: #1D5D99; font-size: 24px;" v-else>0</span>人
                            </p>
                            <p>其中，弃考
                                <span v-if="detail.qkNameList">{{ detail.qkNameList.length }}人</span>
                                <span v-else>0人</span>
                            </p>
                            <p>弃考率
                                <span v-if="detail.qkRate">{{ detail.qkRate }}%</span>
                                <span v-else>0%</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="report_bg">
                    <div class="report_bg_wrap">
                        <div class="report_bg_header">
                            <div class="report_bg_tips">
                                <span>03</span>
                            </div>
                            <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                        </div>
                        <div class="report_bg_title">总体评价</div>
                        <div class="report_content">
                            <div id="mainChart" class="chart_class"></div>
                            <p>在有效答题的人员中，{{ detail.passingRate }}%达到了及格线，{{ detail.yxRate }}%属于优秀</p>
                            <p>优秀人员不仅体现在综合评分优秀，在各大模块领域中也居于上游，体现出综合能力水平的全面发挥及稳定表现。对于这部分人员来说，是一个用心的人，无论是为人处世，还是解决问题，全面发展、样样精通，在行业中已经超越了92%的人。接下来，广阔天地将任其大有作为，终身学习也会带给他们强劲的自信与发展空间。
                            </p>
                            <p>对于良好与及格的人员来说，日新月异、频繁更替的工作能力要求，让财税人面对的问题属实不少。无论是在擅长领域深度学习，还是在全面发展上查缺补漏，都需要发挥主观能动性和强大的学习能力、求实精神、创新精神，建立有效的自我约束和外部激励与监督，把自身的才华和能量充分释放出来。
                            </p>
                            <p>对于有待提高的人员来说，实践是检验知识掌握程度的演武场。虽然现在还有很多问题不能够解决，但是只要多学习、多观察、多总结，知道自己哪里有不足，就有针对性地来学习、成长，解决学习培养与应用实践脱节的突出问题，就一定会成为解决复杂问题的重要人才。
                            </p>
                            <p>在最关注的各项模块中，整体表现更为出色的胜任力是职业综合素养，体现了整体团队的团队合作、抗压能力、追求卓越、文化韧性等，这一系列优秀精神品质，会形成深厚文化底蕴，是公司企业文化建设的生命力之所在。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="report_bg">
                    <div class="report_bg_wrap">
                        <div class="report_bg_header">
                            <div class="report_bg_tips">
                                <span>04</span>
                            </div>
                            <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                        </div>
                        <div class="report_bg_title">总体评价</div>
                        <div class="report_content">
                            <p style="color: #1D5D99;">总成绩分布表</p>
                            <div class="content_table">
                                <div class="contentn_table_wrap">
                                    <div>优秀</div>
                                    <div v-if="detail.resultTotal && detail.resultTotal['优秀']">
                                        {{ detail.resultTotal['优秀'].join(',') }}</div>
                                    <div v-else></div>
                                </div>
                                <div class="contentn_table_wrap">
                                    <div>良好</div>
                                    <div v-if="detail.resultTotal && detail.resultTotal['良好']">
                                        {{ detail.resultTotal['良好'].join(',') }}</div>
                                    <div v-else></div>
                                </div>
                                <div class="contentn_table_wrap">
                                    <div>及格</div>
                                    <div v-if="detail.resultTotal && detail.resultTotal['及格']">
                                        {{ detail.resultTotal['及格'].join(',') }}</div>
                                    <div v-else></div>
                                </div>
                                <div class="contentn_table_wrap">
                                    <div>有待提高</div>
                                    <div v-if="detail.resultTotal && detail.resultTotal['有待提高']">
                                        {{ detail.resultTotal['有待提高'].join(',') }}</div>
                                    <div v-else></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分类统计信息 -->
                <div v-for="(item, index) in detail.categoryName" :key="index">
                    <div class="report_bg">
                        <div class="report_bg_wrap">
                            <div class="report_bg_header">
                                <div class="report_bg_tips">
                                    <span v-if="item.index < 10">0{{ item.index }}</span>
                                    <span v-else>{{ item.index }}</span>
                                </div>
                                <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                            </div>
                            <div class="report_bg_title">{{ item.categoryName }}能力模块</div>
                            <div class="report_content">
                                <div :id="'charts' + index" class="chart_class"></div>
                                <p>在有效答题的人员中，{{ item.gradePassingRate }}%达到了及格线，{{ item.gradeYxRate }}%属于优秀</p>
                                <div v-if="item.categoryName == '管理会计'">
                                    <p>在21世纪，会计人员的工作重点已经不能局限于记账、报账，这些都将为财税信息化所逐步替代。增强价值创造力才是企业的内在需要，而管理会计正是增强价值创造力的必要手段或工具。管理会计主要服务于单位（包括企业和行政事业单位）内部管理需要，是通过利用相关信息，有机融合财务与业务活动，在单位规划、决策、控制和评价等方面发挥重要作用的管理活动。全面推进管理会计体系建设，是推动会计工作转型升级的重点所在，那么加强管理会计人才队伍建设就是管理会计人才培养转型升级的重点所在。
                                    </p>
                                    <p>从测评来看，将管理会计工作落到实处，理论联系实际带动管理会计整体发展，将管理会计应用推向纵深发展，既能为贵公司打造会计工作“升级版”储备人才资源，也能反哺贵公司事业蒸蒸日上。
                                    </p>
                                    <p>对该模块测评中优秀的人来说，必须具备开放、敏捷的思维，充分对新技术、新模式、新思维有着充分的求知欲，知晓可能会对企业或者自身带来哪些影响，同时要学会如何去运用他们。这对那些乐于改变、善于学习的人来说，会带来更多的正向效果。
                                    </p>
                                    <p>对于良好与及格的人员来说，管理会计领域大有作为！如何构建业财融合的财务报告分析体系，利用报表、数据、模型、管理会计工具，建立纵贯企业全部经营管理链条，覆盖各个产品、市场、项目等的多维度指标体系，开展价值跟踪分析，准确反映价值结果，深入揭示价值成因。探索研究利益相关方和行业利益共生报表，更好地用财务语言反映企业发展生态，仍值得继续探索、成长！
                                    </p>
                                    <p>对于有待提高的人员来说，增强价值创造力才是企业的内在需要，而管理会计正是增强价值创造力的必要手段或工具。向管理会计人才转型，一是知识扩充，二是实践积累。要实现成功转型，必须转变思想观念、培养全局意识，必须加强业务学习、完善知识体系，必须注重分析思考、创新管理会计实践。面对如此的未来，当须勇毅前行！
                                    </p>
                                </div>
                                <div v-else-if="item.categoryName == '税务会计'">
                                    <p>此外，当前中国已基本建成以“双随机、一公开”监管和“互联网＋监管”为基本手段、以重点监管为补充、以“信用风险”监管为基础的税务监管新体系，实现从“以票管税”向“以数治税”分类精准监管转变，功能强大的智慧税务、国内一流的智能化行政应用系统，全方位地提高了税务执法、服务、监管能力。这都对企业从事涉税工作带来了工作方法、工作意识、工作内容、工作要求等的巨大转变。
                                    </p>
                                    <p>近年来，国资委发布的《关于中央企业加快建设世界一流财务管理体系的指导意见》（国资发财评规〔2022〕23号）也指出，不断夯实税务管理等基础保障职能。包括推进集团化税务管理，建立税务政策、资源、信息、数据的统筹调度和使用机制，加强财税政策研究，完善对重大经营决策的税务支持机制，强化业务源头涉税事项管控，提高自动化处理水平，挖掘税务数据价值，加强税务风险防控，统筹风险控制与成本优化等等。其重要性不言而喻。
                                    </p>
                                    <p>从测评来看，建议仍需贯彻终身学习理念，将国资发财评规〔2022〕23号等税务管理要求结合企业实际情况落到实处，科学培养、使用与企业高质量发展目标相匹配的复合型财税人才。
                                    </p>
                                    <p>对该模块测评中优秀的人来说，做好企业税务管理，必须结合企业实际情况落到实处，科学学习、持续学习，并去其他标杆企业走走看看、丰富阅历。同时，二十届三中全会的召开，明确了五年内财税体制改革的重点方向及内容，并直接影响企业的税负和盈利能力，进而影响投资和运营决策，需要优秀的人才为此出谋划策！
                                    </p>
                                    <p>对于良好与及格的人员来说，金税四期系统依托政府部门间信息共享，在“以数治税”的大背景下，税务征管、检查手段在朝着精准化、高效化、数智化、信息化方向发展。纳税人进行财税合规、规范经营，才是企业的长远经营之道。税务会计需要熟悉并遵守国家税法、规章和纳税义务，确保企业的财税行为合法合规。并且能够收集和分析税务信息，为企业管理者提供科学、合理的决策依据，通过分析不同税费对企业经营及利润的影响，帮助企业选择更为有效的经营策略。
                                    </p>
                                    <p>对于有待提高的人员来说，学习税收政策不能局限在自身工作时常用的条文上面。如果想要获得更广更深的知识面与敏感度，还需要在政策学习上多下功夫。毕竟，如果不能学懂读透政策条文及其背后蕴含的政策导向，必然是不能做好财税基本工作的。
                                    </p>
                                </div>
                                <div v-else-if="item.categoryName == '财务会计'">
                                    <p>经济越发展，会计越重要。会计是以货币为主要计量单位，‌反映和监督一个单位经济活动的一种经济管理工作。其基本职能包括进行会计核算和实施会计监督两个方面。同时，会计是连接权利和利益的纽带，是治理公司的一个核心问题。公司治理的核心问题是会计模式以及具体反映会计模式的会计制度的选择。它通过对一个企业的财务状况、经营成果、现金流量的揭示，来对经营者的业绩进行评价。
                                    </p>
                                    <p>此外，财务会计工作是一项非常细致、非常庞大的系统工程，是开展管理会计等活动的基石。财务会计人员的道德水准和专业胜任能力不仅涉及财务造假、决策有用等会计信息质量，更涉及现代化经济体系的建设和国家治理体系的基础稳固性。
                                    </p>
                                    <p>虽然当前人工智能改变了财务会计的实践方式、提高了财务工作的效率，但财务会计重要性并未降低。任何企业都不应不重视财务会计工作、不重视财务会计人员的能力素质。</p>
                                    <p>对该模块测评中优秀的人来说，其会计知识储备与运用能力很充足。但在商业环境频繁更新的当今，统筹制定企业财务数字化转型规划，完善制度体系、组织体系和管控体系，加强跨部门、跨板块协同合作，建立智慧、敏捷、系统、深入、前瞻的数字化、智能化财务等等诸多方面，仍大有作为。需要继续努力！
                                    </p>
                                    <p>对于良好与及格的人员来说，AI时代智能工具的介入无疑能够进一步减少财会人员的机械劳动，提升其工作效率和管理能力。但在以“AI驱动”为核心的企业管理新时代下，财务会计如何更好实现财务会计报告的目标，向财务会计报告使用者提供与企业财务状况、经营成果和现金流量等有关的会计信息，反映企业管理层受托责任履行情况，有助于财务会计报告使用者作出经济决策，值得继续努力深思、学习进步！
                                    </p>
                                    <p>对于有待提高的人员来说，财务会计工作看起来好做，但是做好了很难。对于最基本的会计来说，涵盖的知识面广，虽然不是那么的深。有时候一类业务学得差不多了，另一类业务就无法贯通。因此，无论是做工作还是考证书，都需要有优秀的老师带领学习，结合实践进行分析和思考，通过反复练习来加深对财务会计知识的理解与掌握。
                                    </p>
                                </div>
                                <div v-else-if="item.categoryName == '内部审计'">
                                    <p>该模块聚焦于职责、风险、合规、制度、检查等方面。</p>
                                    <p>职责权限是指为了保证职责的有效履行，任职者必须具备的，对某事项进行决策的范围和程度。在财税方面，经济业务事项和会计事项的记账人员、审批人员、经办人员、财物保管人员的职责权限应当明确，并相互分离、相互制约。制度建设是为充分有效地使用各种资源，达到既定管理目标，而在单位内部实施的各种制约和调节的组织、计划、程序和方法。风险管理是对危险发生的可能性和后果的预先管控。管控得力，风险就小。无视放任，终将爆雷。
                                    </p>
                                    <p>对该模块测评中优秀的人来说，已经洞察了职责权限有效配置带来的好处与规避的风险。对眼前纷繁的业务事项与人际关系已能抽丝剥茧搬拆解并找出其中的风险隐患。财税风险管理需要有前瞻性的风险预防意识，过程管理需要有多维度，全方位的扫描分析和管理。唯有如此才能在业务前端不给企业埋下财税之雷，才能在业务开展中将可能存在的雷排查出。继续努力！
                                    </p>
                                    <p>对于良好与及格的人员来说，优秀公司会把具有规律性的问题找出来，用一套职责权限制度来解决反复发生的问题。有了相应的制度与高效的执行力，就可以解决大多数问题。</p>
                                    <p>对于有待提高的人员来说，是不是还没有掌握快速诊断企业制度缺陷的方法，还不能评价制度的效果并进行改进？会计法等财税制度都要求各单位应当建立、健全内部会计监督制度。确保各岗位人员的职责权限应当明确，并相互分离、相互制约。因此，需要继续学习有关政策规定，并在工作中努力发现职责权限制度缺失带给企业的弊端与风险。
                                    </p>
                                    <p></p>
                                </div>
                                <div v-else-if="item.categoryName == '职业综合素养'">
                                    <p>不同个体在职业活动和社会生活中担任不同角色，社会对其职业素养有不同的核心要求。在企业，一批政治坚定、善于创新、勇于担当、乐于奉献、廉洁自律、团结协作，具有较强组织协调能力，能够凝聚优秀人才、增强团队合力、发挥团队优势，实现团队效应最大化的人才队伍，是不可多得的宝贵财富。这些锤炼出来的一系列优秀精神品质，会形成深厚的文化底蕴，是公司企业文化建设的生命力之所在。
                                    </p>
                                    <p>对该模块测评中优秀的人来说，卓越团队不需要领导者去督促团队成员竭尽全力工作，因为他们很清楚需要做什么。他们会彼此提醒注意那些无助于成功的行为和活动，而正是这种无怨无悔的付出才造就了他们对彼此负责、勇于承担的品质。
                                    </p>
                                    <p>对于良好与及格的人员来说，考试时答案大多是有标准答案的，但工作中却没有唯一答案。需要因地制宜做出更合适、更具创新性的努力来完成工作。当下要做的不是达到合格线，而是要超越别人，做到更好。此外，一个有团队协作精神的团队是允许良性冲突存在的，要学会识别虚假的和谐，引导和鼓励适当的、建设性的冲突。这是一个杂乱的、费时的过程，但这不可避免的。
                                    </p>
                                    <p>对于有待提高的人员来说，理论与实践之间的差异有大有小，这都需要亲力亲为去感知、去弥合、去转换。今天的每一次小步行进，都是为了将来的大步跨越而积累经验。团队协作并不只是大家一起做事这么简单，它更需要的是发挥各自的优势与团队间的信任，以及自我奉献精神。需要重新审视自己，还有哪些做的不够，还请继续努力。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="report_bg">
                        <div class="report_bg_wrap">
                            <div class="report_bg_header">
                                <div class="report_bg_tips">
                                    <span v-if="(item.index + 1) < 10">0{{ item.index + 1 }}</span>
                                    <span v-else>{{ item.index + 1 }}</span>
                                </div>
                                <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                            </div>
                            <div class="report_bg_title">{{ item.categoryName }}能力模块</div>
                            <div class="report_content">
                                <p style="color: #1D5D99;">{{ item.categoryName }}能力成绩分布表</p>
                                <div class="content_table">
                                    <div class="contentn_table_wrap">
                                        <div>优秀</div>
                                        <div v-if="item['优秀']">{{ item['优秀'].join(',') }}</div>
                                        <div v-else></div>
                                    </div>
                                    <div class="contentn_table_wrap">
                                        <div>良好</div>
                                        <div v-if="item['良好']">{{ item['良好'].join(',') }}</div>
                                        <div v-else></div>
                                    </div>
                                    <div class="contentn_table_wrap">
                                        <div>及格</div>
                                        <div v-if="item['及格']">{{ item['及格'].join(',') }}</div>
                                        <div v-else></div>
                                    </div>
                                    <div class="contentn_table_wrap">
                                        <div>有待提高</div>
                                        <div v-if="item['有待提高']">{{ item['有待提高'].join(',') }}</div>
                                        <div v-else></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="report_bg">
                    <div class="report_bg_wrap">
                        <div class="report_bg_header">
                            <div class="report_bg_tips">
                                <span v-if="lastIndex < 10">0{{ lastIndex }}</span>
                                <span v-else>{{ lastIndex }}</span>
                            </div>
                            <div class="report_bg_tip">人才综合能力测评报告（{{ detail.year }}）</div>
                        </div>
                        <div class="report_bg_title">结语</div>
                        <div class="report_content">
                            <p>企业理想的人才需求和市场上实际的人才素质水平存在种种不吻合，在任何时候都不能避免。因此，企业在进行关键岗位筛选前，可设置在岗位上最关注的核心胜任力项，同时区分可被培养的胜任力项和短期内不可进行培养的胜任力项，结合企业在未来的人才培养和管理上因材施教，因材施“管”。通过有效手段识别出他们是企业最需要的能力，由此，各行业都将有优秀的人才愿意为之奋斗。
                            </p>
                            <p style="color: #1D5D99;">附：弃考人员名单</p>
                            <p v-if="detail.qkNameList">{{ detail.qkNameList.join(',') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getEvaluationReport

} from "@/api/index.js";

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf';
import { Loading } from 'element-ui';

import Header from "@/components/Header.vue";

export default {
    name: "companyReport",
    components: {
        Header,
    },
    data() {
        return {
            detail: {}, //结果值
            userPaperId: "", //当前试卷id
            name: "",
            id: null,
            lastIndex: 4,
            myChart: null,
            option: {}, //图表的初始化数据
            myTheme: {}, //图标的自定义主题色
            deptId: null,
            token: null,
        }
    },
    created() {
        var token = window.localStorage.getItem('token');
        var dept = window.localStorage.getItem('TopDeptId');
        if (token) {


            this.token = token;
        }
        if (dept) {
            this.deptId = dept;
        }

        this.id = this.$route.params.id
        this.name = this.$route.params.name

        this.myTheme = {
            color: ['#da70d6', '#5470c6', '#91cc75', '#fac858'],
        }
        this.$nextTick(() => {
            this.getlistMap()
        })
    },
    activated() { },
    methods: {
        async exportPDF() {
            const loadingInstance = Loading.service({ fullscreen: true, text: '文件下载中...' });
            const dom = document.getElementById('reportBox')
            html2canvas(dom, {
                useCORS: true, //解决网络图片跨域问题
                width: dom.width,
                height: dom.height,
                windowWidth: dom.scrollWidth,
                dpi: window.devicePixelRatio * 3, // 将分辨率提高到特定的DPI 提高四倍
                scale: 3, // 按比例增加分辨率
            }).then((canvas) => {
                const pdf = new jsPDF('p', 'mm', 'a4') // A4纸，纵向
                const ctx = canvas.getContext('2d')
                const a4w = 210
                const a4h = 297 // A4大小，210mm x 297mm
                const imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
                let renderedHeight = 0
                while (renderedHeight < canvas.height) {
                    const page = document.createElement('canvas')
                    page.width = canvas.width
                    // 可能内容不足一页
                    page.height = Math.min(imgHeight, canvas.height - renderedHeight)
                    // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                    page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width,
                        Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
                    // 添加图像到页面，保留10mm边距
                    pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, a4w, Math.min(a4h,
                        a4w * page.height / page.width))
                    renderedHeight += imgHeight
                    if (renderedHeight < canvas.height) {
                        pdf.addPage() // 如果后面还有内容，添加一个空页
                    }
                }
                // 保存文件
                pdf.save(`${this.detail.deptName}-统计报告.pdf`)
                loadingInstance.close()
            })
        },

        exportImg() {
            const loadingInstance = Loading.service({ fullscreen: true, text: '文件下载中...' });
            let dom = document.getElementById('reportBox')
            html2canvas(dom).then(canvas => {
                const imgData = canvas.toDataURL('image/png')
                const link = document.createElement('a')
                link.style.display = 'none'
                document.body.appendChild(link)
                link.href = imgData
                link.download = this.detail.deptName + '-统计报告.png'
                link.click()
                loadingInstance.close()
            })
        },

        goTo() {
            this.$router.go(-1)

        },

        getlistMap() {
            this.loading = true;
            getEvaluationReport({
                id: this.id,
            }, {
                Authorization: this.token
            }).then((res) => {
                if (res.code === 200) {
                    this.detail = res.data
                    let index = 5
                    for (let i = 0; i < res.data.categoryName.length; i++) {
                        if (i == 0) {
                            res.data.categoryName[0].index = 5
                        } else {
                            res.data.categoryName[i].index = index
                        }
                        index = index + 2
                    }
                    this.lastIndex = this.detail.categoryName ? index : 5
                    this.$nextTick(() => {
                        let chartDom = document.getElementById('mainChart')
                        let chartDom0 = document.getElementById('charts0')
                        let chartDom1 = document.getElementById('charts1')
                        let chartDom2 = document.getElementById('charts2')
                        let chartDom3 = document.getElementById('charts3')
                        let chartDom4 = document.getElementById('charts4')
                        if (this.detail.resultTotal) {
                            this.initChart(this.detail.resultTotal, chartDom)
                        }
                        if (chartDom0) {
                            this.initChart(this.detail.categoryName[0], chartDom0)
                        }
                        if (chartDom1) {
                            this.initChart(this.detail.categoryName[1], chartDom1)
                        }
                        if (chartDom2) {
                            this.initChart(this.detail.categoryName[2], chartDom2)
                        }
                        if (chartDom3) {
                            this.initChart(this.detail.categoryName[3], chartDom3)
                        }
                        if (chartDom4) {
                            this.initChart(this.detail.categoryName[4], chartDom4)
                        }
                    })
                    this.loading = false
                }
            }).catch((error) => {
                this.loading = false
            })
        },
        initChart(data, chartDom) {
            this.option = {
                title: {},
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} (人)'
                },
                legend: {
                    bottom: 10,
                    left: 'center',
                    data: ['优秀', '良好', '及格', '有待提高']
                },
                series: [{
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    selectedMode: 'single',
                    label: {
                        show: true,
                        formatter: '{b}\n({c}人)'
                    },
                    data: [{
                        value: data['优秀'] ? data['优秀'].length : 0,
                        name: '优秀'
                    },
                    {
                        value: data['良好'] ? data['良好'].length : 0,
                        name: '良好'
                    },
                    {
                        value: data['及格'] ? data['及格'].length : 0,
                        name: '及格'
                    },
                    {
                        value: data['有待提高'] ? data['有待提高'].length : 0,
                        name: '有待提高'
                    },
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            }

            // 渲染图表
            let myChart = this.$echarts.init(chartDom, this.myTheme)
            this.option && myChart.setOption(this.option)
        },


    },
}
</script>

<style lang="less" scoped>
.companyEva_wrap {
    padding-top: 130px;

    .btn_wrap {
        width: 1000px;
        position: relative;
        margin: 0 auto;

        .downLoad_class {



            position: absolute;
            top: 10px;
            right: -40px;

        }
    }

    .report-box {
        width: 840px;
        margin: 0 auto;

        .report_1 {
            height: 1188px;
            position: relative;

            img {
                width: 100%;
                height: auto;
            }

            .report_1_wrap {
                position: absolute;
                top: 16%;
                left: 50px;

                .report_title {
                    font-size: 34px;
                    color: #1D5D99;
                    text-align: left;
                    font-weight: normal;
                }

                .report_name {
                    font-size: 48px;
                    color: #1D5D99;
                    text-align: left;
                    margin: 20px 0 10px;
                }

                .report_year {
                    font-size: 44px;
                    color: #1D5D99;
                    text-align: left;
                }
            }
        }

        .report_bg {
            height: 1188px;
            position: relative;
            background: url('../../assets/report/bottom2.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: bottom center;
            &::after {
                content: '';
                display: block;
                background: url('../../assets/report/bottom1.png');
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 45px;
                background-repeat: no-repeat;
                background-size: 100%;
                background-position: 0;
            }
            img {
                width: 100%;
                height: auto;
            }

            .report_bg_wrap {
                padding-bottom: 80px;

                .report_bg_header {
                    display: flex;
                    padding: 30px 20px;
                    font-size: 16px;
                    color: #1D5D99;
                    align-items: center;

                    .report_bg_tips {
                        font-weight: 600;
                        font-size: 20px;
                        color: #333;
                        position: relative;
                        width: 16px;

                        &::before {
                            content: '';
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            background: url('../../assets/report/tipsbg.png');
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            background-position: 0 0;
                            width: 20px;
                            height: 8px;
                        }
                    }

                    .report_bg_tip {
                        position: relative;
                        padding-left: 15px;
                        flex: 1;
                        text-align: left;

                        &::before {
                            content: '';
                            height: 0;
                            width: 56px;
                            border-top: 1px solid #000;
                            transform: rotate(115deg);
                            -o-transform: rotate(115deg);
                            -moz-transform: rotate(115deg);
                            -webkit-transform: rotate(115deg);
                            position: relative;
                            top: -7px;
                            left: -8px;
                            position: absolute;
                        }
                    }
                }

                .report_bg_title {
                    font-size: 34px;
                    color: #484E53;
                    text-align: left;
                    margin: 0 30px;
                    font-weight: 600;
                    border-bottom: 1px solid #000;
                    position: relative;

                    &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        background: url('../../assets/report/2.png');
                        background-repeat: no-repeat;
                        background-size: 100%;
                        background-position: 0 0;
                        width: 60px;
                        height: 42px;
                    }
                }

                .report_content {
                    margin: 20px 30px 0;

                    p {
                        text-align: left;
                        font-size: 14px;
                        color: #484E53;
                        margin-bottom: 15px;
                        line-height: 20px;
                    }

                    .content_table {
                        font-size: 14px;

                        .contentn_table_wrap {
                            display: flex;
                            align-items: stretch;
                            justify-content: center;
                            border-bottom: 1px solid #fff;

                            div {
                                padding: 10px 16px;

                                &:first-child {
                                    width: 108px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background: #FFE5D1;
                                }

                                &:last-child {
                                    flex: 1;
                                    text-align: left;
                                    line-height: 20px;
                                    background: #F8F8F8;
                                }
                            }
                        }
                    }
                }
            }

            .chart_class {
                width: 100%;
                height: 450px;
            }
        }

        .report_3 {
            .report_content {
                p {
                    margin-bottom: 40px;
                }
            }
        }
    }
}
</style>